import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ElementRef,
  ViewChild,
} from '@angular/core';
import { MatDatepicker } from '@angular/material/datepicker';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { OrderStatus, EDPStatus, EDPStatusLabel} from 'src/app/shared/constants/constants';
import { environment } from 'src/environments/environment';
import { CommonService } from 'src/app/services/common-services/common.service';
import { OmsServiceService } from '../service/oms-service.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { OmsReturnConfirmComponent } from './oms-return-confirm/oms-return-confirm.component';

@Component({
  selector: 'app-oms-details',
  templateUrl: './oms-return.component.html',
  styleUrls: ['./oms-return.component.scss'],
})
export class OmsReturnComponent implements OnInit {
  @ViewChild('mileCheckbox0', { static: false }) mileCheckbox0?: ElementRef;

  isPanelExpanded: boolean = false;
  isPanelDisabled: boolean = false;
  showButton: boolean = false;
  skipBtn: boolean = false;
  orderId = Number(this.route.snapshot.paramMap.get('id'));
  baseUrl = environment.BASE_URL;
  orderDetail: any;
  isChecked: boolean[] = [];
  OrderStatus = OrderStatus;
  EDPStatus = EDPStatus;
  EDPStatusLabel: any = EDPStatusLabel;
  showMilestones = false;
  subMilestoneData: any = '';
  selectedId: number[] = [];
  selectDate: any = null;

  @Input() disabled: boolean = false;
  @Output() checkedChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  milestones: any;
  getIndex: any;
  getMilesId: number[] = [];
  milestonesIds: any;
  getMilestones: any;

  selectedMileStones: Map<number, any> = new Map();
  yesterday = new Date();

  constructor(
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private omsService: OmsServiceService,
    private router: Router,
    private dialog: MatDialog,
  ) {}
  ngOnInit(): void {
    this.getOrderById();
    this.selectDate = new Date();
    this.selectDate.setDate(this.selectDate.getDate());
    this.yesterday.setDate(this.yesterday.getDate() - 0);
  }

  openDatePicker(datePicker: MatDatepicker<Date>) {
    datePicker.open();
  }

  selectedDate(event: any): void {
    this.selectDate = event.value;
  }

  getOrderById() {
    this.omsService.getById(this.orderId).subscribe((data: any) => {
      this.orderDetail = data?.response;

      this.orderDetail?.customerEdp?.customerMilestones.forEach(
        (mile: any, index: number) => {
          mile['comments'] = '';
          mile['subMileStoneId'] = '';
          mile['milestoneStartDate'] = mile.startDate;
          mile['milestoneEndDate'] = mile.endDate;
          mile['subMilestoneStartDate'] = mile.subMilestones?.startDate;
          mile['subMilestoneEndDate'] = mile.subMilestones?.endDate;
          mile['freezeCheckbox'] = this.isCheckboxDisabled(mile);

          if (mile['freezeCheckbox']) {
            this.selectedMileStones.set(index, mile);
          }
        },
      );
    });
  }

  isCheckboxDisabled(milestoneData: any): boolean {
    return milestoneData['milestoneStartDate'] && milestoneData['milestoneEndDate'];
  }

  isCheckedSelect(): boolean {
    return this.selectedMileStones.size > 0;
  }

  returnEdp() {
    const milePayload = Array.from(this.selectedMileStones.values()).map((mile: any) => ({
      id: mile.id,
      startDate: mile.startDate,
      endDate: mile.endDate,
      status: 'NEW',
      milestoneChats: [
        {
          comment: mile.comments,
          commentBy: 'customer',
        },
      ],
    }));

    const payload = {
      id: this.orderId,
      customerEdp: {
        id: this.orderDetail?.customerEdp?.id,
        edpAdminStatus: EDPStatus.EDP_RETURN,
        edpSupplerStatus: EDPStatus.EDP_RETURN,
        edpCustomerStatus: EDPStatus.EDP_RETURN,
        milestones: milePayload,
      },
    };

    this.omsService.update(payload).subscribe(() => {
      this.toastr.success('EDP returned');
      this.router.navigate(['/oms/orders']);
    });
  }

  confirmReturn() {
    let config = new MatDialogConfig();
    config = {
      disableClose: true,
      data: {
        edpName: this.orderDetail.projectName,
      },
    };

    const dialogRef = this.dialog.open(OmsReturnConfirmComponent, config);
    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result) {
        this.returnEdp();
      }
    });
  }

  checkMilestones(checked: boolean, index: number, mile: any) {
    if (checked) {
      this.selectedMileStones.set(index, mile);
    } else {
      this.selectedMileStones.delete(index);
    }
  }

  getEdpStatusLabel(status: string): EDPStatusLabel {
    return this.EDPStatusLabel[status];
  }
}
